import STLFileIcon from 'components/Icons/STLFileIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { openFreshPartFile } from 'store/actions'

export const StlDownloader = ({ partId, t }) => {
	const dispatch = useDispatch()
	const url = useSelector(state =>
		(/** @type {StoreState} */(state)).CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === partId)?.fileLinks?.stlModel
	)
	const tooltipId = partId + '_stl'

	return (
		<div>
			{url ?
				<div className="cursor" onClick={() => dispatch(openFreshPartFile(partId, 'stlModel', url))} data-tip={t('download_stl', { ns: 'naming' })} data-for={tooltipId}>
					<STLFileIcon tooltipMessage={t('download_stl', { ns: 'naming' })} />
				</div> :
				<div>

				</div>
			}
			<ReactTooltip
				id={tooltipId}
				place="top"
				type="info"
				effect="solid"
				multiline={false}
			/>
		</div>)
}

StlDownloader.propTypes = {
	partId: PropTypes.number,
	t: PropTypes.func,
}

export default withTranslation()(StlDownloader)
